import {css, Theme, useTheme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {Container} from "@pg-design/grid-module";
import {
    borderRadius,
    calculateRemSize,
    flex,
    flexAbsoluteCenter,
    flexAlignCenter,
    flexDirection,
    m,
    mb,
    mt,
    onDesktop,
    p,
    ph,
    resetWidth,
    w100
} from "@pg-design/helpers-css";
import {CheckboxCheckedIconV2} from "@pg-design/icons-module";
import {Picture} from "@pg-design/picture-module";
import {Text} from "@pg-design/text";
import {CREDIT_PAGES_IDS} from "@pg-mono/test-ids";

import {IconWithElement} from "../IconWithElement";

const pdfFile = "/static-rp/pdf/kredyt_hipoteczny_krok_po_kroku.pdf";
const ebookPicture = require("../../images/ebook-kredyt.png");

const paragraphs = [
    "Co wpływa na zdolność kredytową",
    "Kiedy podpisać umowę z deweloperem",
    "Kiedy bank wydaje ostateczną decyzję kredytową",
    "Gdzie i kiedy wpłacić wkład własny"
];

export const CreditStepByStep = () => {
    const theme = useTheme();

    const iconProps = {
        size: "3.2",
        wrapperSize: "3.2",
        wrapperColor: theme.colors.primary
    };
    return (
        <Container as="section">
            <Container css={descriptionWrapper}>
                <div css={pictureColumn}>
                    <Picture
                        sources={[
                            {minWidthPX: 0, src: ebookPicture, height: 353, width: 248},
                            {minWidthPX: 768, src: ebookPicture, height: 457, width: 322}
                        ]}
                        alt="E-book krok po kroku"
                        fit="center"
                    />
                </div>
                <div css={ebookColumn}>
                    <div css={flexDirection("column")}>
                        <Text variant="headline_3" as="h2" css={mb(3)}>
                            Kredyt hipoteczny krok po kroku
                        </Text>
                        <Text variant="body_copy_0" css={mb(4)}>
                            Kompletne i praktyczne kompendium wiedzy o kredycie hipotecznym.
                        </Text>
                        <Text variant="headline_6" as="p" css={mb(4)}>
                            Z tego e-booka dowiesz się m.in.:
                        </Text>
                        {paragraphs.map((paragraph, index) => (
                            <IconWithElement key={index} icon={CheckboxCheckedIconV2} containerStyle={iconWitchElementStyle} iconProps={iconProps}>
                                <Text variant="body_copy_0">{paragraph}</Text>
                            </IconWithElement>
                        ))}

                        <div css={buttonWrapper}>
                            <Button
                                href={pdfFile}
                                css={buttonStyle}
                                variant="filled_primary"
                                dataTestId={CREDIT_PAGES_IDS.COMPARE_CREDITS_SUBPAGE.DOWNLOAD_EBOOK_BUTTON}
                            >
                                pobierz e-book
                            </Button>
                        </div>
                    </div>
                </div>
            </Container>
        </Container>
    );
};

const buttonWrapper = (theme: Theme) => css`
    ${flexAbsoluteCenter};
    ${w100};
    ${mt(4)};

    @media (min-width: ${theme.breakpoints.sm}) {
        ${flex()}
    }
`;
const buttonStyle = (theme: Theme) => css`
    ${w100};
    @media (min-width: ${theme.breakpoints.sm}) {
        ${resetWidth}
    }
`;

const descriptionWrapper = css`
    ${p(5, 1.5, 4, 1.5)};

    ${w100};
    background-color: #e1d7cd;
    ${flexDirection("column")};
    ${borderRadius(3)};

    ${onDesktop(css`
        ${ph(3)};
        ${flex()}
        ${flexDirection("row")};
        max-width: 112.8rem;
    `)};
`;

const pictureColumn = (theme: Theme) => css`
    ${w100};

    img {
        max-height: 353px;
        height: 100%;
        width: auto;
        ${m(0, "auto")};
        box-shadow: 0 1.6rem 6rem 0 #aeb1b499;
    }

    @media (min-width: ${theme.breakpoints.sm}) {
        flex: 1 1 40%;
        img {
            max-height: 457px;
        }
    }
`;

const ebookColumn = (theme: Theme) => css`
    ${w100};
    ${p(3, 1.5, 0, 1.5)};
    @media (min-width: ${theme.breakpoints.md}) {
        flex: 1 1 60%;
        ${flex()};
        ${flexAlignCenter};
        flex-wrap: wrap;
        ${p(0, 3)};
    }
`;
const iconWitchElementStyle = css`
    ${flex("flex-start", "flex-start")};
    ${flexDirection("row")};
    gap: ${calculateRemSize(2)};
    ${mb(1)};
`;
import {css, Theme, useTheme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {Container} from "@pg-design/grid-module";
import {
    borderRadius,
    calculateRemSize,
    flex,
    flexAbsoluteCenter,
    flexAlignCenter,
    flexDirection,
    m,
    mb,
    mt,
    onDesktop,
    p,
    ph,
    resetWidth,
    w100
} from "@pg-design/helpers-css";
import {CheckboxCheckedIconV2} from "@pg-design/icons-module";
import {Picture} from "@pg-design/picture-module";
import {Text} from "@pg-design/text";
import {CREDIT_PAGES_IDS} from "@pg-mono/test-ids";

import {IconWithElement} from "../IconWithElement";

const pdfFile = "/static-rp/pdf/kredyt_hipoteczny_krok_po_kroku.pdf";
const ebookPicture = require("../../images/ebook-kredyt.png");

const paragraphs = [
    "Co wpływa na zdolność kredytową",
    "Kiedy podpisać umowę z deweloperem",
    "Kiedy bank wydaje ostateczną decyzję kredytową",
    "Gdzie i kiedy wpłacić wkład własny"
];

export const CreditStepByStep = () => {
    const theme = useTheme();

    const iconProps = {
        size: "3.2",
        wrapperSize: "3.2",
        wrapperColor: theme.colors.primary
    };
    return (
        <Container as="section">
            <Container css={descriptionWrapper}>
                <div css={pictureColumn}>
                    <Picture
                        sources={[
                            {minWidthPX: 0, src: ebookPicture, height: 353, width: 248},
                            {minWidthPX: 768, src: ebookPicture, height: 457, width: 322}
                        ]}
                        alt="E-book krok po kroku"
                        fit="center"
                    />
                </div>
                <div css={ebookColumn}>
                    <div css={flexDirection("column")}>
                        <Text variant="headline_3" as="h2" css={mb(3)}>
                            Kredyt hipoteczny krok po kroku
                        </Text>
                        <Text variant="body_copy_0" css={mb(4)}>
                            Kompletne i praktyczne kompendium wiedzy o kredycie hipotecznym.
                        </Text>
                        <Text variant="headline_6" as="p" css={mb(4)}>
                            Z tego e-booka dowiesz się m.in.:
                        </Text>
                        {paragraphs.map((paragraph, index) => (
                            <IconWithElement key={index} icon={CheckboxCheckedIconV2} containerStyle={iconWitchElementStyle} iconProps={iconProps}>
                                <Text variant="body_copy_0">{paragraph}</Text>
                            </IconWithElement>
                        ))}

                        <div css={buttonWrapper}>
                            <Button
                                href={pdfFile}
                                css={buttonStyle}
                                variant="filled_primary"
                                dataTestId={CREDIT_PAGES_IDS.COMPARE_CREDITS_SUBPAGE.DOWNLOAD_EBOOK_BUTTON}
                            >
                                pobierz e-book
                            </Button>
                        </div>
                    </div>
                </div>
            </Container>
        </Container>
    );
};

const buttonWrapper = (theme: Theme) => css`
    ${flexAbsoluteCenter};
    ${w100};
    ${mt(4)};

    @media (min-width: ${theme.breakpoints.sm}) {
        ${flex()}
    }
`;
const buttonStyle = (theme: Theme) => css`
    ${w100};
    @media (min-width: ${theme.breakpoints.sm}) {
        ${resetWidth}
    }
`;

const descriptionWrapper = css`
    ${p(5, 1.5, 4, 1.5)};

    ${w100};
    background-color: #e1d7cd;
    ${flexDirection("column")};
    ${borderRadius(3)};

    ${onDesktop(css`
        ${ph(3)};
        ${flex()}
        ${flexDirection("row")};
        max-width: 112.8rem;
    `)};
`;

const pictureColumn = (theme: Theme) => css`
    ${w100};

    img {
        max-height: 353px;
        height: 100%;
        width: auto;
        ${m(0, "auto")};
        box-shadow: 0 1.6rem 6rem 0 #aeb1b499;
    }

    @media (min-width: ${theme.breakpoints.sm}) {
        flex: 1 1 40%;
        img {
            max-height: 457px;
        }
    }
`;

const ebookColumn = (theme: Theme) => css`
    ${w100};
    ${p(3, 1.5, 0, 1.5)};
    @media (min-width: ${theme.breakpoints.md}) {
        flex: 1 1 60%;
        ${flex()};
        ${flexAlignCenter};
        flex-wrap: wrap;
        ${p(0, 3)};
    }
`;
const iconWitchElementStyle = css`
    ${flex("flex-start", "flex-start")};
    ${flexDirection("row")};
    gap: ${calculateRemSize(2)};
    ${mb(1)};
`;
